import { render } from "./Wangdditor.vue?vue&type=template&id=624fe908&scoped=true"
import script from "./Wangdditor.vue?vue&type=script&lang=js"
export * from "./Wangdditor.vue?vue&type=script&lang=js"

import "./Wangdditor.vue?vue&type=style&index=0&id=624fe908&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624fe908"]])

export default __exports__